import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { WidgetInput } from "react-addressfinder";
import "react-addressfinder/dist/widget.css";
import { getNBNApiHeader } from 'utlis/commonfunctions';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";











const ConnectionForm = ({ buy, vispID, address, onSuccess, onActiveSuccess, userToken }) => {

  const SERVER_URL = process.env.REACT_APP_API_URL;
  const apiKey = process.env.REACT_APP_API_TOKEN;
  const [apiMessage, setApiMessage] = useState([]);
  const [apiStatus, setApiStatusCode] = useState('');
  const [apiCalled, setApiCalled] = useState(false);
  const [isAsap, setIsAsap] = useState(false);
  const [checkAsServiceAddress, setCheckAsServiceAddress] = useState(false);
  const [haveFinderValue, setHaveFinderValue] = useState(false);
  const [minDate, setMinDate] = useState('');
  const [orderType, setOrderType] = useState('');
  const apiUrl = process.env.REACT_APP_API_URL;
  const [error,setError] = useState("")
  const [previousProvider, setPreviousProvider] = useState(false);
  const [formData, setFormData] = useState({
    inputAddress: address,
    fixedRequestedConnectionDate: new Date(),
    delivery_address: '',
    visp_qualification_id: vispID,
    fixedOrderAs: '',
    as_soon_as_possible: isAsap,
    customer_id: '12',
    person_accepting_delivery: '',
    customer_company_name: '',
    previous_provider_name: '',
    current_provider_avcid: '',
    home_phone_avaialability: '',
    nbn_box_availability:'',
    orderType:''

  });


  const[portDob,setPortDob]=useState("")


  
  const today = new Date();
  const currentYear = today.getFullYear();
  //const endDate = `${currentYear + 5}-12-31`;

  const [date, setDate] = useState(null);
  const [selectedDate, setSelectedDate] = useState(today);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value
    });
    
  };


  const setMinimumDate = () => {
    const today = new Date().toISOString().split('T')[0];
    setMinDate(today);
  };

  const handleAddressFinderChange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value
    });
    setHaveFinderValue(true)
  };

  const AddressFinderComponent = ({ addressFinderKey, inputClassName, id, onChange }) => {
    const handleSelectedAddress = (fullAddress, searchAddress) => {
      onChange('delivery_address', fullAddress);
    };

    return (
      <WidgetInput
        addressFinderKey={addressFinderKey}
        inputClassName={inputClassName}
        id={id}
        onSelected={handleSelectedAddress}
      />
    );
  };

  const handleASAP = (e) => {
    const isChecked = e.target.checked;
    if (isChecked) {

      setIsAsap(true)
      setFormData({
        ...formData,
        as_soon_as_possible: true
      });

    } else {

      setIsAsap(false)
    }

  }
  const handleOrderType = (e) => {
    const { name, value } = e.target;
    if(value==='transfer'){

      setPreviousProvider(true)

    } else {

      setPreviousProvider(false)
    }
    setFormData({ ...formData, [name]: value });
  }
  const handleSubmit = async(e) => {
    e.preventDefault();
    const  headers = await getNBNApiHeader()
    axios.post(`${SERVER_URL}nbn/customer-connection-details`, formData, {
      headers: headers
    })
      .then(response => {
        setApiStatusCode(response.data.status);
        setApiMessage(response.data.message);
        setApiCalled(true);
        setTimeout(() => {

          setApiCalled(false);
          onSuccess(e); // Pass data to onSuccess
          onActiveSuccess();
        }, 2000);
      })
      .catch(error => {

        setApiCalled(true);
        setApiStatusCode(false);

        const errorMessage = error.response.data.message;
        setApiMessage(errorMessage);
      })
      .finally(() => {
        setTimeout(() => {
          setApiCalled(false);
        }, 10000);
      });
  };

  

  const handleServiceAddress = (e) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setCheckAsServiceAddress(true)
      setFormData({
        ...formData,
        delivery_address: address
      });

    } else {
      setHaveFinderValue(false)
      setCheckAsServiceAddress(false)
      setFormData({
        ...formData,
        delivery_address: ''
      });
    }
  };


  const handleHomePhone = (e) => {
    const { name, value } = e.target;
    if(name==='home_phone_avaialability'){
      if(value==='yes'){
        setError('Please note that Telsim does not support voice, if you are transferring the services to Telsim with landline/homephone, the phone services will get disconnected.');
        setTimeout(() => {
          setFormData({
            ...formData,
            [name]: value.slice(0, 60)
          });
        }, 2000);
      }else{
        setError("")
      }
    }else{
      setError("")
    }
    setFormData({ ...formData, [name]: value });
  };

  useEffect(() => {
    setMinimumDate();
    fetchOrderType();
  }, [])



  const formatDate = (date) => {
    // formats a JS date to 'yyyy-mm-dd'
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();
    console.log(day)

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };


  
  const handleDateChange = (date) => {
    setDate(date);
    const formattedDate = formatDate(date);
    setSelectedDate(formattedDate);


    setFormData({
      ...formData,
      ['fixedRequestedConnectionDate']: formattedDate
    });


  };
  async function fetchOrderType() {
    const headers = await getNBNApiHeader();
    try {
      const post_data = { 
        visp_qualification_id:vispID
      };
      const response = await axios.post(apiUrl + 'nbn/nbn-order-types',post_data, { headers: headers });
      if (response.status === 200) {
        console.log("data:",response.data.data)
        if(response.data.data.ordertypes!=null){
          setOrderType(response.data.data.ordertypes);
        }
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }

  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1;


  function calculateEndYear() {
    const today = new Date();
    const currentYear = today.getFullYear();
    const endYear = currentYear + 20;
    return endYear;
  }


  const endYear = calculateEndYear();
  const endDate = `${endYear}-12-31`;


  return (


    <div id="Account" className="tabcontent">
      <section className="get-plan" style={{ marginTop: '0!important;' }}>
        <div className="container" style={{ backgroundColor: '#fff', borderTopLeftRadius: '30px', borderBottomRightRadius: '30px' }}>
          <form className="contact-form row" onSubmit={handleSubmit}>
            <div className="form-field col-lg-12">
              <b style={{ color: '#777', float: 'left' }}>Service activation Details</b>
            </div>
            <div className="form-field col-lg-12">
              <label className="label" htmlFor="inputAddress">Service Address </label>
              <input type="text"  autoComplete="off" className="input-text js-input" name="inputAddress" value={address} disabled onChange={handleChange} />
            </div>
            {isAsap ? <div className="form-field col-lg-12 prfActivationDate">
              <label className="label" htmlFor="fixedRequestedConnectionDate">Preferred activation date <span style={{ color: '#777' }}>(DD/MM/YYYY)</span></label>
              <input type="text"  autoComplete="off" className="input-text js-input" name="fixedRequestedConnectionDate" value="ASAP" disabled />
            </div> :

              <div className="form-field col-lg-12">
                <label className="label  prf-label" htmlFor="mobile">Preferred activation date  </label>
                {/* <DropdownDate
                  startDate={today}
                  endDate={endDate}
                  selectedDate={selectedDate}
                  onDateChange={handleDateChange} /> */}

                <DatePicker
                  selected={selectedDate}
                  onChange={(date) => {
                   // const formattedDate = date ? date.toISOString().split('T')[0] : '';
                    const formattedDate = date ? date.toLocaleDateString('en-CA') : '';
                    setPortDob(formattedDate);
                    setSelectedDate(formattedDate);
                    setFormData({
                      ...formData,
                      ['fixedRequestedConnectionDate']: formattedDate
                    });
                  }}
                  dateFormat="yyyy-MM-dd"
                  placeholderText="Enter Date of Birth"
                  className="new-date-picker prfact-newdate-picker"
                  wrapperClassName=""
                  id="date"
                  name="date"
                  showYearDropdown
                  showMonthDropdown
                  scrollableYearDropdown
                  yearDropdownItemNumber={100}
                  minDate={new Date()} 
                  maxDate={new Date(new Date().setFullYear(new Date().getFullYear() + 1))}
                  

                />
              </div>
            }
            <div className="form-field check-box-section col-lg-12">
              <label class="check-box">  As soon as possible
                <input type="checkbox" required="" name="as_soon_as_possible" value={formData.as_soon_as_possible} onChange={handleASAP} />
                <span class="tick"></span>
              </label>
            </div>
            <div className="form-field col-lg-12">
              <label className="label"  htmlFor="mobile">Order As </label>
              <select name='orderType' required value={formData.orderType} onChange={handleOrderType} >
                {orderType ? (
                <>
                  <option value="" style={{ backgroundColor: '#f5f5f5' }} >Select  Order Type</option>
                  {orderType.map((ordertype) => (
                    <option key={ordertype.value} value={ordertype.value}>
                      {ordertype.label}
                    </option>
                  ))}
                </>
                ) : (
                  <option value=""></option>
                )}
              </select>
              
            </div>
            <div className="form-field col-lg-12">
              <label className="label nbn-box-label"  htmlFor="mobile">NBN Box Availabile </label>
              <select name='nbn_box_availability' required value={formData.nbn_box_availability} onChange={handleChange}>
                      <option value="" style={{ backgroundColor: '#f5f5f5' }}>Select option</option>
                      <option key='yes' value='yes'>Yes
                      </option>
                      <option key='no' value='no'>No
                      </option>
              </select>
            </div>
            <div className="form-field col-lg-12">
              <label className="label nbn-box-label"  htmlFor="mobile">Voice/Home Phone Availabile</label>
              <select name='home_phone_avaialability' required  value={formData.home_phone_avaialability} onChange={handleHomePhone} error={error}>
                      <option value="" style={{ backgroundColor: '#f5f5f5' }}>Select Voice/Home Phone Availability</option>
                      <option key='yes' value='yes'>Yes
                      </option>
                      <option key='no' value='no'>No
                      </option>
              </select>
            </div>
            <div className="form-field check-box-section col-lg-12"> 
              <label  style={{ color: '#ff0000', float: 'left',fontSize:'small' }}>{error}</label>
            </div>
            <div className="form-field col-lg-12">
              <label className="label nbn-box-label"  htmlFor="mobile">Current provider AVC ID <span style={{ color: '#777' }}>(Optional)</span></label>
              <input type="text"  autoComplete="off" className="input-text js-input" name="current_provider_avcid" value={formData.current_provider_avcid} onChange={handleChange} />
            </div>
            {previousProvider ?
            <div className="form-field col-lg-12">
              <label className="label"  htmlFor="mobile">Previous Provider Name </label>
              <input type="text"  required autoComplete="off" className="input-text js-input" name="previous_provider_name" value={formData.previous_provider_name}  onChange={handleChange}/>
            </div>
            : '' }

           <div className="form-field col-lg-12">
              <b style={{ color: '#777', float: 'left' }}>Delivery Details</b>
            </div>
            <div className="form-field col-lg-12">
              <label className="label" htmlFor="delivery_address">Delivery address</label>

              {checkAsServiceAddress
                ?
                <input type="text" className="input-text js-input" name="delivery_address" disabled readOnly value={formData.delivery_address} onChange={handleChange} />
                :
                <>
                  {haveFinderValue
                    ?
                    <div style={{ position: 'relative' }}>
                      <input type="text" className="input-text js-input" name="delivery_address" disabled readOnly value={formData.delivery_address} />
                      <span
                        style={{
                          position: 'absolute',
                          right: '10px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          backgroundColor: 'transparent',
                          color: 'red',
                          border: 'none',
                          padding: '5px 10px',
                          cursor: 'pointer'
                        }}
                        onClick={() => {
                          setHaveFinderValue(false)
                          setFormData({
                            ...formData,
                            delivery_address: ''
                          });
                        }}
                      >
                        x
                      </span>
                    </div>
                    :
                    <AddressFinderComponent
                      addressFinderKey="UJCFN4HL6YRMT3D9K8PG"
                      inputClassName="input-text js-input"
                      id="address"
                      value={formData.delivery_address}
                      onChange={(name, value) => handleAddressFinderChange(name, value)}
                    />}
                </>
              }
            </div>
            <div className="form-field check-box-section col-lg-12">
              <label class="check-box"> Same as service address
                <input type="checkbox" required="" onChange={(event)=>{handleServiceAddress(event)}} />
                <span class="tick"></span>
              </label>
            </div>
            <div className="form-field col-lg-12">
              <label className="label"  htmlFor="mobile">Full name <span style={{ color: '#777' }}>(Person accepting delivery)</span></label>
              <input type="text"  autoComplete="off" className="input-text js-input" name="person_accepting_delivery" value={formData.person_accepting_delivery} onChange={handleChange} />
            </div>
            {/* <div className="form-field col-lg-12">
              <label className="label"   htmlFor="mobile">Company Name <span style={{ color: '#777' }}>(if applicable)</span></label>
              <input type="text"  autoComplete="off" className="input-text js-input" name="customer_company_name" value={formData.customer_company_name} onChange={handleChange} />
            </div> */}
            <div className="form-field col-lg-12">
              <div className="row">
                {/* <div className="form-field col-lg-6">
                  <input className="payment-back-btn" type="submit" value="BACK" />
                </div> */}
                <div className="form-field col-lg-12">
                  <input className="payment-submit-btn" type="submit" disabled={apiCalled} value={apiCalled ? 'Loading...' : 'CONTINUE'} onClick={buy} />
                </div>
              </div>
            </div>
          </form>
          {apiCalled && apiMessage && (
            <div className={"alert " + (apiStatus === 200 ? "alert-success" : "alert-danger")} style={{ textAlign: 'left' }}>
              <strong>{apiStatus === 200 ? "Please wait...." : ""}</strong>
              {apiMessage.delivery_address && (<strong style={{ display: 'block' }}>{apiMessage.delivery_address ? apiMessage.delivery_address : apiMessage}</strong>)}
              {apiMessage.fixedRequestedConnectionDate && (<strong style={{ display: 'block' }}>{apiMessage.fixedRequestedConnectionDate ? apiMessage.fixedRequestedConnectionDate : apiMessage}</strong>)}
            </div>
          )}

        </div>
      </section>
    </div>




  );
}

export default ConnectionForm;